import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createCategory, createPrivacy, fetchCategory, fetchPrivacy, fetchPrivacyById, removeCategory, updateCategory, updatePrivacy } from "../../service/api";

export const getPrivacy = createAsyncThunk(
    "privacy/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPrivacy(params)
            console.log("privacy", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const getPrivacyById = createAsyncThunk(
    "privacy/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPrivacyById(params)
            console.log("privacy byid", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const addPrivacy = createAsyncThunk(
    "privacy/add",
    async (params, { rejectWithValue }) => {

        try {
            const response = await createPrivacy(params)
            console.log("privacy", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const editPrivacy = createAsyncThunk(
    "category/edit",
    async (params, { rejectWithValue }) => {

        try {
            const response = await updatePrivacy(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)






const privacySlice = createSlice({
    name: "privacies",
    initialState: {
        privacyList: [],
        privacyById: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPrivacy.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getPrivacy.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.privacyList = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getPrivacy.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            // By id

            .addCase(getPrivacyById.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getPrivacyById.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.privacyById = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getPrivacyById.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //Post 

            .addCase(addPrivacy.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(addPrivacy.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(addPrivacy.rejected, (state) => {
                state.actionLoader = false
            })

            //put 

            .addCase(editPrivacy.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(editPrivacy.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(editPrivacy.rejected, (state) => {
                state.actionLoader = false
            })


    }
})

export default privacySlice.reducer